import { SelectableModel } from '@app/component/autocomplete/abstract-autocomplete/selectable-model';
import { Organisation } from '@shared/organisation/organisation';

export class FieldAffiliate extends SelectableModel {
  name!: string;
  code!: string;

  organisations: Organisation[] = [];
}
